<template>
  <w-tooltip
    v-model='open'
    :content-class='`w-speed-dial-button${disabled ? "__disabled" : ""}`'
    :bottom='false'
    transition='scale-transition'
    left
  >
    <template #tooltip-activator='{ on, attrs }'>
      <w-icon-button
        v-bind="attrs"
        :disabled='disabled'
        :icon="icon"
        :outlined="false"
        v-on="on"
        @click="$emit('click')"
      />
    </template>

    <template #tooltip>
      {{ label }}
    </template>
  </w-tooltip>
</template>

<script>
export default {
  name: 'WorkSpeedDialButton',
  props: {
    open: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    icon: { type: String, required: true },
    color: { type: String, default: 'primary' },
    label: { type: String, required: true }
  }
};
</script>

<style lang='scss'>
.v-tooltip__content.menuable__content__active {
  opacity: 1;
  &.w-speed-dial-button__disabled{
    background-color: var(--v-primary-lighten3) !important;
  }
}
</style>
